/* eslint no-multi-spaces: 0 */

import Vue            from 'vue'
import Router         from 'vue-router'
import { routerHistory, writeHistory } from 'vue-router-back-button'

import User           from '@/core/user'
// import Login          from '@/components/Login'
import ModulesWrapper from '@/components/ModulesWrapper'
import NotFound       from '@/components/GeneralViews/NotFound.vue'

Vue.use(Router)
Vue.use(routerHistory)

const routes = [
  {
    name: 'login',
    path: '/login',
    component: ModulesWrapper.publicShell
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    name: 'home',
    path: '/home',
    redirect: global.config && global.config.start || '/d/Reports'
  },
  {
    path: '/:namespace/:page?/:section?/:action?',
    name: '_allModules',
    component: ModulesWrapper.shell,
    meta: { requiresAuth: !global.config }
  },
  { name: '404', path: '/404', component: NotFound },
  { name: 'nogo', path: '*', redirect: '404' }
]

const router = new Router({
  routes,
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    //
    document.querySelector('.main-panel').scrollTop = 0
  }
})

/**
 * Hook into routes for checking user authorization
 * before navigation else redirect to login
 * @summary Navigation guard
 */
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // Check authorization and redirect to login if failed
    const user = User.get()

    if (!user || !user.token) {
      next({name: 'login'})
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(writeHistory)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js